import { __decorate } from "tslib";
import $ from 'jquery';
import { throttle } from 'helpful-decorators';
export default class DisplayColorsInOneLine {
    static $colors = $('.js__display-colors-in-one-line');
    static colorSelectHeight = 18;
    static init() {
        if (!this.$colors.length) {
            return;
        }
        this.hideColors();
        $(window).on('resize', this.handleResize.bind(this));
    }
    static hideColors() {
        this.$colors.each((index, element) => {
            const $colors = $(element);
            const height = $colors.height() || 0;
            if (height > this.colorSelectHeight) {
                $colors.find('.js__color-select-item:not(.d-none)').last().addClass('d-none');
                this.hideColors();
            }
        });
    }
    static handleResize() {
        $('.js__color-select-item').removeClass('d-none');
        this.hideColors();
    }
}
__decorate([
    throttle(300)
], DisplayColorsInOneLine, "handleResize", null);
